const demosection = {
  id: '1',
  title: 'READY TO GET STARTED?',
  description: 'Hire at scale with the click of a button.',
  button: 'Get a Demo',
  link: '/contact-us',
}
export default demosection
